import React, { useState } from 'react';
import { AddUser } from '../utils/usersAPI';
import { Button, TextField, Grid, Typography, Container } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { AppbarContainer, AppbarHeader } from '../styles/headerStyle';


const RegistrationForm = () => {
    //אתחול האובייקט באמצעות useState עם השדות הרלוונטיות להרשמה
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        phone: '',
        address: ''
        // Add more fields as needed
    });
    //במקרה של שגיאה
    const [error, setError] = useState('');
    const navigate = useNavigate();//מופע של הפונקציה עם יכולת הניווט

    //פונקציה שתעדכן את השדה המתאים באובייקט כאשר הערכים משתנים
    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({
    //         ...formData,
    //         [name]: value
    //     });
    // };

    // //פונקציה המטפלת בהגשת הטופס וניגשת לכל נתוני רישום המשתמש המאוחסנים באובייקט
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //         await AddUser(formData).then(res => {
    //             console.log(res);
    //             if(res.status === 200){
    //                 alert("נרשמת בהצלחה:)");
    //             }
    //         }).catch((error) =>{
    //         setError('ההרשמה נכשלה, נסה שנית')
    //     })
    // };

  const handleSubmit = async (e) => {
  e.preventDefault();

  // בדיקה שכל השדות מולאו
  if (!formData.name || !formData.email || !formData.password ||!formData.phone || !formData.address) {
    setError('חובה למלא את כל השדות');
    return;
  }
  
  if (formData.password.length < 6) {
  setError('הסיסמה חייבת להכיל לפחות 6 תווים');
  return;
}

  // ולידציית כתובת
  const addressError = validateAddress(formData.address);
  if (addressError) {
    setErrors(prev => ({ ...prev, address: addressError }));
    setError('יש לתקן את הכתובת');
    return;
  }

  // בדיקת אימייל
  const emailRegex = /^\S+@\S+\.\S+$/;
  if (!emailRegex.test(formData.email)) {
    setError('כתובת האימייל אינה חוקית');
    return;
  }

  // ✅ רק אם הכל עבר – שולחים לשרת
  try {
    const res = await AddUser(formData);
    if (res.status === 200) {
      alert("נרשמת בהצלחה :)");
      navigate("/");
    }
} catch (err) {
  setError(err.response?.data || 'ההרשמה נכשלה, נסה שנית');
}
};

    const validateAddress = (address) => {
        if (!address) return "יש להזין כתובת";

        const parts = address.trim().split(/\s+/);

        if (parts.length < 3) {
            return "יש להזין שם רחוב, מספר ועיר";
        }

        const hasNumber = parts.some(p => /\d+/.test(p));
        if (!hasNumber) {
            return "חסר מספר בית";
        }

        return "";
    };

    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({ ...prev, [name]: value }));

        if (name === "address") {
            setErrors(prev => ({
                ...prev,
                address: validateAddress(value)
            }));
        }
    };



    return (
        <>
            {/* <AppbarContainer>
                    <AppbarHeader>Welcome to Shine's Stock</AppbarHeader>
                </AppbarContainer> */}
            <Container maxWidth="xs" style={{ marginTop: '140px' }}></Container>
            <Container maxWidth="xs" style={{ marginTop: '140px' }}>
                <Typography variant="h4" align="center" gutterBottom>
                    רישום משתמש חדש
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label="שם מתשמש"
                                name="name"
                                fullWidth
                                value={formData.name}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        {/* מספר טלפון */}
                        <Grid item xs={12}>
                            <TextField
                                label="מספר טלפון"
                                name="phone"
                                type="tel"
                                fullWidth
                                value={formData.phone}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        {/* כתובת למשלוח */}
                        <Grid item xs={12}>
                            <TextField
                                label="כתובת למשלוח"
                                name="address"
                                fullWidth
                                placeholder="שם רחוב, מספר, עיר"
                                value={formData.address}
                                onChange={handleInputChange}
                                error={!!errors.address}
                                helperText={errors.address}

                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="כתובת מייל"
                                name="email"
                                type="email"
                                fullWidth
                                value={formData.email}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="סיסמה"
                                name="password"
                                type="password"
                                fullWidth
                                value={formData.password}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        {error && <span>{error}</span>}
                    </Grid>
                    <Button type="submit" variant="contained" color="primary" fullWidth >
                        הרשמה
                    </Button>
                </form>
            </Container>
        </>
    );
};

export default RegistrationForm;